export default "__VITE_ASSET__2f0d4ae7__"